(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("locale/locale_tr", [], factory);
	else if(typeof exports === 'object')
		exports["locale/locale_tr"] = factory();
	else
		root["locale/locale_tr"] = factory();
})(window, function() {
return 